import { render } from "./EmptyPrivateStream.vue?vue&type=template&id=87e7018e&scoped=true"
import script from "./EmptyPrivateStream.vue?vue&type=script&lang=js"
export * from "./EmptyPrivateStream.vue?vue&type=script&lang=js"

import "./EmptyPrivateStream.vue?vue&type=style&index=0&id=87e7018e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-87e7018e"

export default script